import { Divider, Stack, Typography } from '@mui/material';
import { useMutation } from '@tanstack/react-query';
import { useState } from 'react';

import { _setKycToken } from '@/api/auth/mutations';
import { KycSdk } from '@/app/providers/kyc-sdk';
import { ShuftiProKyc } from '@/app/providers/shuftipro-kyc';
import LockFilledGreenIcon from '@/assets/svg/ui-elements/lock-filled-green.svg';
import { useGlobalModal } from '@/global-hooks/use-global-modal';
import { CustomButton } from '@/shared/components/custom-button';
import CustomModal from '@/shared/components/custom-modal';

const KycProvider = {
  sumsub: 'sumsub',
  shuftiPro: 'ShuftiPro',
} as const;

const activeKycProvider = KycProvider.shuftiPro as (typeof KycProvider)[keyof typeof KycProvider];

export const KycStartModal = () => {
  const { open, handleClose } = useGlobalModal('KYC_START_MODAL');

  const [token, setToken] = useState('');
  const { mutate, isPending } = useMutation({ mutationFn: _setKycToken });

  const handleKyc = () => {
    mutate(undefined, {
      onSuccess: (data) => {
        setToken(data.token);
      },
    });
  };

  const handleModalClose = () => {
    setToken('');
    handleClose();
  };

  return (
    <CustomModal
      open={open}
      onClose={handleModalClose}
      withCloseButton
      title="KYC verification"
      sx={{
        maxWidth: activeKycProvider === KycProvider.shuftiPro ? '830px' : '480px',
      }}
    >
      <>
        <Divider sx={{ margin: '16px 0 24px' }} />

        {!token ? (
          <>
            <Stack flexDirection="column" alignItems="center" mb="32px">
              <LockFilledGreenIcon style={{ marginBottom: '16px' }} />
              <Typography fontWeight="medium">
                Complete identity verification (KYC) and start investing
              </Typography>
            </Stack>
            <CustomButton
              variant="contained"
              sx={{ mb: '16px' }}
              fullWidth
              size="large"
              onClick={handleKyc}
              disabled={isPending}
            >
              {isPending ? 'Loading...' : 'Start KYC'}
            </CustomButton>
            <CustomButton onClick={handleModalClose} fullWidth size="large">
              I will KYC later
            </CustomButton>
          </>
        ) : activeKycProvider === KycProvider.sumsub ? (
          <KycSdk token={token} />
        ) : activeKycProvider === KycProvider.shuftiPro ? (
          <ShuftiProKyc verificationUrl={token} />
        ) : null}
      </>
    </CustomModal>
  );
};
